<template>
  <a-drawer
    :title="`${edit ? '编辑' : '新增'}`"
    placement="right"
    :closable="false"
    :maskClosable="false"
    @close="() => changeVisible(false)"
    v-model:visible="siteBarVisible"
    width="500"
  >
    <div v-if="edit" class="df mb20">
      <div class="w120">站点：{{ postParams.siteName }}</div>
      <div class="w120">终端：{{ postParams.terminalName }}</div>
      <template v-for="item in moduleTypeOptons" :key="item.value">
        <div style="width: 200px;" v-if="item.value == postParams.moduleType">
          位置：{{ item.label }}
        </div>
      </template>
    </div>
    <div v-if="!edit">
      <div class="mb10">站点</div>
      <div class="mb14">
        <a-checkbox-group
          :disabled="edit"
          v-model:value="postParams.siteIds"
          class="acg"
        >
          <a-checkbox :value="item.id" v-for="(item, key) in sites" :key="key">
            <a-tooltip>
              <template #title>{{ item.name }}</template>
              <div class="ellipsis">{{ item.name }}</div>
            </a-tooltip>
          </a-checkbox>
        </a-checkbox-group>
      </div>
      <div class="mb10">终端</div>
      <div class="mb14">
        <a-checkbox-group
          :disabled="edit"
          v-model:value="postParams.terminalIds"
          class="acg"
        >
          <a-checkbox
            :value="item.value"
            v-for="(item, key) in terminalOptions"
            :key="key"
            >{{ item.label }}</a-checkbox
          >
        </a-checkbox-group>
      </div>
      <div class="mb10">位置</div>
      <div class="mb14">
        <a-radio-group
          :disabled="edit"
          v-model:value="postParams.moduleType"
          class="acg"
        >
          <a-radio
            :value="item.value"
            v-for="(item, key) in moduleTypeOptons"
            :key="key"
            >{{ item.label }}</a-radio
          >
        </a-radio-group>
      </div>
    </div>
    <div class="mb10">主商品SKC：</div>
    <div class="mb14">
      <a-input
        v-model:value="postParams.mainSkc"
        placeholder="请输入"
        :maxlength="100"
        :disabled="edit"
        @blur="
          postParams.mainSkc = postParams.mainSkc
            ? postParams.mainSkc.trim()
            : ''
        "
      ></a-input>
    </div>
    <div class="mb10">坑位1</div>
    <div class="mb14" style="width: 440px;">
      <a-input
        v-model:value="categories1"
        placeholder="请输入"
        :maxlength="100"
        @blur="categories1 = categories1.trim()"
      ></a-input>
    </div>
    <div class="mb10">坑位2</div>
    <div class="mb14" style="width: 440px;">
      <a-input
        v-model:value="categories2"
        placeholder="请输入"
        :maxlength="100"
        @blur="categories2 = categories2.trim()"
      ></a-input>
    </div>
    <div class="mb10">坑位3</div>
    <div class="mb14" style="width: 440px;">
      <a-input
        v-model:value="categories3"
        placeholder="请输入"
        :maxlength="100"
        @blur="categories3 = categories3.trim()"
      ></a-input>
    </div>
    <div class="mb10">坑位4</div>
    <div class="mb14" style="width: 440px;">
      <a-input
        v-model:value="categories4"
        placeholder="请输入"
        :maxlength="100"
        @blur="categories4 = categories4.trim()"
      ></a-input>
    </div>
    <div class="mb10">坑位5</div>
    <div class="mb100" style="width: 440px;">
      <a-input
        v-model:value="categories5"
        placeholder="请输入"
        :maxlength="100"
        @blur="categories5 = categories5.trim()"
      ></a-input>
    </div>
    <div class="siderFooter">
      <div>
        <a-button type="default" class="mr10" @click="() => cancel()"
          >取消</a-button
        >
        <!-- 编辑保存 -->
        <a-button type="primary" @click="modify(edit)" class="mr10"
          >保存</a-button
        >
      </div>
    </div>
  </a-drawer>
</template>
<script>
import { inject, toRefs } from 'vue'
import { TreeSelect } from 'ant-design-vue'
export default {
  setup() {
    return {
      SHOW_PARENT: TreeSelect.SHOW_PARENT,
      ...toRefs(inject('initState'))
    }
  }
}
</script>
<style scoped>
.ellipsis {
  width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.acg {
  display: flex;
  flex-wrap: wrap;
}

.siderFooter {
  width: 100%;
  padding: 10px 0;
  background: #ffffff;
  border-top: 1px solid #ddd;
  position: absolute;
  bottom: 0;
  left: 0;
  text-align: right;
}
</style>
<style>
.ant-checkbox-group.acg .ant-checkbox-wrapper {
  margin-left: 8px;
}
</style>
